import React from 'react';
import Slider from 'react-slick';
import '../../../app/home/section/carousel.css';

import Banner from '../../../asset/banner/banner.png';
import Banner2 from '../../../asset/banner/banner2.png';
import Data from '../../../helper/data';
import useMediaQuery from '@mui/material/useMediaQuery';

const Carousel = () => {

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    speed: 2000,
    autoplaySpeed: 2000,
    prevArrow: false,
    nextArrow: false,



  };

  const is430Below = useMediaQuery('(min-width:430px)')

  return (
    <div>

      {
        is430Below ? (
          <Slider {...settings}>
          {
            Data[1].banners.map((value) => {
              return (
                <div>
                  <img src={value.bg_img} width="100%" style={{ maxHeight: '50vh' }} />
                </div>
              )
            })
          }



        </Slider>
       
        ) : (
          <Slider {...settings}>
          {
            Data[1].banners.map((value) => {
              return (
                <div>
                  <img src={value.bg_img} width="100%" style={{ maxHeight: '50vh' }} />
                </div>
              )
            })
          }



        </Slider>

        )
      }


    </div>
  )
}

export default Carousel;